import {
  useParams,
} from 'react-router';

import {
  Flex,
} from 'web-styled';

import {
  Chat,
} from 'web-components';

const ClientMessages = () => {
  const { id } = useParams();

  return (
    <Flex fillSpace noScroll>
      <Chat id={id || 'new'} />
    </Flex>
  );
};

export default ClientMessages;
